
import { AcademicCapIcon as HeroAcademicCapIcon } from '@heroicons/react/24/outline';
export const AcademicCapIcon = HeroAcademicCapIcon;
